import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// components
import Iconify from '../iconify';
import Image from '../image';

// ----------------------------------------------------------------------

export default function SingleFilePreview({ imgUrl = '', file }) {
  const location = file?.location;

  return (
    <Box
      sx={{
        p: 1,
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        position: 'absolute',
      }}
    >
      <Image
        alt="file preview"
        src={imgUrl}
        sx={{
          width: 1,
          height: 1,
          borderRadius: 1,
        }}
      />

      {location && (
        <Box
          sx={{
            left: 12,
            right: 12,
            bottom: 12,
            position: 'absolute',
            p: 1,
            borderRadius: 0.75,
            bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            color: 'common.white',
            zIndex: 9,
          }}
        >
          <Stack spacing={0.5}>
            <Typography variant="caption" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontWeight: 'bold' }}>
              <Iconify icon="solar:map-point-bold" width={14} />
              LAT: {location.latitude.toFixed(6)} | LNG: {location.longitude.toFixed(6)}
            </Typography>
            {location.address && (
              <Typography variant="caption" sx={{ opacity: 0.8, fontSize: '0.65rem', lineHeight: 1.2 }}>
                {location.address}
              </Typography>
            )}
          </Stack>
        </Box>
      )}
    </Box>
  );
}

SingleFilePreview.propTypes = {
  imgUrl: PropTypes.string,
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
